import { ChevronDown } from "lucide-react";
import { useState } from "react";

export const priorityOptions = [
  { value: "Urgent", label: "Urgent / First Available" },
  { value: "Medium", label: "Normal" },
  { value: "Low", label: "Advisory / Future Scheduling" },
];

export const contactRoleOptions = [
  { value: "Aircraft owner", label: "Aircraft owner" },
  { value: "Pilot or Aircraft Manager", label: "Pilot or Aircraft Manager" },
  {
    value: "Third-Party (Line Service, MX Service, FBO)",
    label: "Third-Party (Line Service, MX Service, FBO)",
  },
];

export const contactPreferenceOptions = [
  { value: "no preference", label: "No preference" },
  { value: "email", label: "Email" },
  { value: "text", label: "Text" },
  { value: "phone", label: "Phone" },
];

export const serviceOptions = [
  "Media: Photo Shoot + Condition Video + Marketing Video",
  "Media: Photo Shoot + Condition Video",
  "Flight: Reposition",
  "Flight: Aircraft Demo",
  "Flight: Delivery Flight",
];

export const getServiceOptions = (selectedServices = []) => [
  ...serviceOptions,
  ...selectedServices.filter((service) => !serviceOptions.includes(service)),
];

export function PortalSelect({ value, placeholder, options, onChange, disabled = false }) {
  const [open, setOpen] = useState(false);
  const selected = options.find((option) => option.value === value);

  return (
    <div className="w-full">
      <button
        type="button"
        onClick={() => !disabled && setOpen((current) => !current)}
        disabled={disabled}
        className="flex w-full items-center justify-between gap-3 rounded-md border border-[#D9D9D9] bg-white px-4 py-3 text-left text-sm text-black shadow-sm disabled:cursor-not-allowed disabled:bg-white/70 disabled:text-black/70"
      >
        <span className={selected ? "text-black" : "text-[#9D9D9D]"}>
          {selected?.label || placeholder}
        </span>
        <ChevronDown
          className={`h-5 w-5 shrink-0 text-black transition-transform ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>

      {open && !disabled && (
        <div className="mt-3 overflow-hidden rounded-xl border border-[#D9D9D9] bg-white shadow-lg">
          {options.map((option) => {
            const selectedOption = option.value === value;

            return (
              <button
                key={option.value}
                type="button"
                onClick={() => {
                  onChange(option.value);
                  setOpen(false);
                }}
                className={`block w-full border-b border-black/5 px-4 py-3 text-left text-sm last:border-b-0 ${
                  selectedOption
                    ? "bg-strobe-red text-white"
                    : "text-black hover:bg-strobe-red/10"
                }`}
              >
                {option.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export function PortalServicesDropdown({ selectedServices, onToggle, disabled = false }) {
  const [open, setOpen] = useState(false);
  const options = getServiceOptions(selectedServices);

  return (
    <div className="w-full">
      <button
        type="button"
        onClick={() => !disabled && setOpen((current) => !current)}
        disabled={disabled}
        className="flex w-full items-center justify-between gap-3 rounded-md border border-[#D9D9D9] bg-white px-4 py-3 text-left text-sm text-black shadow-sm disabled:cursor-not-allowed disabled:bg-white/70 disabled:text-black/70"
      >
        <span className={selectedServices.length ? "text-black" : "text-[#9D9D9D]"}>
          {selectedServices.length
            ? `${selectedServices.length} service${selectedServices.length === 1 ? "" : "s"} selected`
            : "Select requested services"}
        </span>
        <ChevronDown
          className={`h-5 w-5 shrink-0 text-black transition-transform ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>

      {open && !disabled && (
        <div className="mt-3 overflow-hidden rounded-xl border border-[#D9D9D9] bg-white shadow-lg">
          {options.map((service) => {
            const selected = selectedServices.includes(service);

            return (
              <label
                key={service}
                className={`flex items-start gap-3 border-b border-black/5 px-4 py-3 text-sm last:border-b-0 ${
                  selected ? "bg-strobe-red text-white" : "text-black"
                }`}
              >
                <input
                  type="checkbox"
                  checked={selected}
                  onChange={() => onToggle(service)}
                  className="mt-0.5 h-4 w-4 accent-strobe-red"
                />
                <span className="leading-snug">{service}</span>
              </label>
            );
          })}
        </div>
      )}

      {selectedServices.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-2">
          {selectedServices.map((service) => (
            <span
              key={service}
              className="rounded-md border border-strobe-red/20 bg-strobe-red/10 px-3 py-1 text-xs text-strobe-red"
            >
              {service}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
